module.exports = __webpack_public_path__ + "static/media/host-command-icon-arrow-push.c03fc260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/host-command-icon-arrow-push.svg
// module id = ./src/assets/images/host-command-icon-arrow-push.svg
// module chunks = 0